export const DotTemplate = ({
  fillColor = '#4D7E7F',
  shadowColor = 'rgba(0, 0, 0, 0.2)'
}) => `
<svg 
  width="18" 
  height="18" 
  viewBox="0 0 18 22" 
  fill="none" 
  xmlns="http://www.w3.org/2000/svg"
>
  <circle 
    cx="9" 
    cy="10" 
    r="8" 
    fill="${shadowColor}"
  />
  <circle 
    cx="9" 
    cy="9" 
    r="6" 
    fill="${fillColor}"
    stroke="white"
    stroke-width="2"
  />
</svg>
`.replace(/\s+/g, ' ').trim()
